import { render, staticRenderFns } from "./CrmSalesAreaCharts.vue?vue&type=template&id=4cb6c814"
import script from "./CrmSalesAreaCharts.vue?vue&type=script&lang=js"
export * from "./CrmSalesAreaCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports